import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../auth/Context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../../adapters/API/axios';
import { Container, Spinner, Table } from 'react-bootstrap';

function PrintPageVisitMasuk ()
{
    const { tokens } = useContext( AuthContext );
    const tokenUser = tokens?.token;
    const { karyawanid } = useParams();
    const [ userDetail, setUserDetail ] = useState();
    const [ detailVisitMasuk, setDetailVisitMasuk ] = useState();
    const [ done, setDone ] = useState( undefined );
    const navigate = useNavigate();

    useEffect( () =>
    {
        const fetchData = async () =>
        {
            if ( karyawanid !== undefined && tokenUser !== undefined ) {

                await fetchUserDetail();
                await fetchListAdetailAbsenMasuk();
            }
        };

        fetchData();
    }, [ karyawanid, tokenUser ] );



    useEffect( () =>
    {
        if ( done ) {
            window.print();
        }
    }, [ done ] );

    useEffect( () =>
    {
        const handleAfterPrint = () =>
        {
            navigate( -1 );
        };

        window.addEventListener( 'afterprint', handleAfterPrint );

        return () =>
        {
            window.removeEventListener( 'afterprint', handleAfterPrint );
        };
    }, [ navigate ] );


    const fetchUserDetail = () =>
    {
        axios.get( `api/users/${karyawanid}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            } )
            .then( res =>
            {

                setUserDetail( res.data );
            } ).catch( err =>
            {
                // console.log( err )
            } )
    };


    const fetchListAdetailAbsenMasuk = () =>
    {
        axios.get( `/api/visit/visitIn/?user_id=${karyawanid}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            } )
            .then( res =>
            {



                setDetailVisitMasuk( res.data );
                setTimeout( () =>
                {
                    setDone( true );
                }, 2000 );

            } ).catch( err =>
            {
                // console.log( err )
            } )
    };


    return (
        <Container fluid style={ { minHeight: '100vh', overflowX: 'hidden' } }>
            <div className='text-start'>
                <h1 className='mt-2' style={ { fontFamily: 'Poppins-Regular' } }>Detail Visit Masuk { userDetail?.first_name } { userDetail?.last_name }</h1>
            </div>
            { !done ? (
                <Container className='text-center mb-3'>
                    <div className='my-5'>
                        <Spinner animation="border" size='lg' style={ customSpinnerStyle } />
                    </div>
                </Container>
            ) : (
                <>
                    <div className='mt-3'>
                        <Table responsive >
                            <thead style={ { fontFamily: 'Poppins-Regular' } }>
                                <tr>
                                    <th>#</th>
                                    <th>Tanggal</th>
                                    <th>Jam</th>
                                    <th>Visit Lokasi Masuk</th>
                                </tr>
                            </thead>
                            <tbody style={ { fontFamily: 'Poppins-Light' } }>
                                {
                                    detailVisitMasuk?.map( ( data, index ) =>
                                    {
                                        return (

                                            <tr key={ index }>
                                                <td>{ index + 1 }</td>
                                                <td>{ data?.visitIn_time.split( 'T' )[ 0 ] }</td>
                                                <td>{ data?.visitIn_time.split( 'T' )[ 1 ].split( '.' )[ 0 ] }</td>
                                                <td>{ data?.visitIn_place }</td>
                                            </tr>

                                        )
                                    } )
                                }
                            </tbody>
                        </Table>
                    </div>
                </>
            ) }
        </Container>
    )
}

export default PrintPageVisitMasuk


const customSpinnerStyle = {
    color: '#000A2E',
};

